// @flow
import EventList from 'components/event/EventList';
import { connect } from 'react-redux';
import type { DispatchType, StateType } from 'types/Actions';
import type { StateProps, DispatchProps } from 'components/event/EventList';

import { fetchEvents } from 'actions/eventsActions';
import { fetchMatchEvents } from 'actions/matchEventsActions';

export default connect(
  (state: StateType): StateProps => ({
    ligue: state.settingsState.ligue,
    events: state.eventsState.events,
    eventsStatus: state.eventsState.status,
    calendarTeamIds: state.settingsState.cat_calendrier_equipes,
    matchEvents: state.matchEventsState.matchEvents,
    matchEventsStatus: state.matchEventsState.status
  }),
  (dispatch: DispatchType): DispatchProps => ({
    fetchEvents: (from: Date, to: Date) => dispatch(fetchEvents(from, to)),
    fetchMatchEvents: (from: Date, to: Date) => dispatch(fetchMatchEvents(from, to)),
  })
)(EventList);
